import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';

import {
	coreDataSecurityAccessExplainerByIdReducers,
	coreDataSecurityAccessExplainerByIdWatchers
} from './_id';
import {
	coreDataSecurityAccessExplainerByObjectIdReducers,
	coreDataSecurityAccessExplainerByObjectIdWatchers
} from './object';
import {
	coreDataSecurityAccessExplainerExportReducers,
	coreDataSecurityAccessExplainerExportWatchers
} from './export';

export const coreDataSecurityAccessExplainerReducers = combineReducers({
	byId: coreDataSecurityAccessExplainerByIdReducers,
	export: coreDataSecurityAccessExplainerExportReducers,
	object: coreDataSecurityAccessExplainerByObjectIdReducers
});

export const coreDataSecurityAccessExplainerWatchers = combineAllWatchers([
	coreDataSecurityAccessExplainerByIdWatchers,
	coreDataSecurityAccessExplainerByObjectIdWatchers,
	coreDataSecurityAccessExplainerExportWatchers
]);
